import React from 'react';
import ReactDOM from 'react-dom';
import MyRouter from './components/router';
import './styles/index.less';


ReactDOM.render(<MyRouter />, document.getElementById('root'));




// WEBPACK FOOTER //
// ./src/index.js